import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Slider } from "primereact/slider";
import { Chart } from "primereact/chart";
import { useSelector, useDispatch } from 'react-redux';
import CommonReportFilter from "./CommonReportFilter";
import moment from "moment";
const CurrentStatusReport = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(null);
    // Bar Graph code start here
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const jobState = useSelector((state) => state.job);
    const protrackReports = useSelector((state) => state.reports);
    const {
        currentReportList,
        currentCommsReportList,
        currentRPCReportList,
    } = protrackReports;
    const {
        appLanguage,
    } = jobState;
    useEffect(() => {
        let rpcGraphVol = currentReportList[0]?.CommStatusGraph ? currentReportList[0]?.CommStatusGraph : [];

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue("--text-color");
        const textColorSecondary = documentStyle.getPropertyValue(
            "--text-color-secondary"
        );
        const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
        const data = {
            labels: rpcGraphVol.map(item => item.TimeGroup),
            datasets: [
                {
                    type: "line",
                    label: appLanguage["report.current-status.label.received"],
                    fill: false,
                    tension: 0.7,
                    borderColor: '#BFBFBF',
                    backgroundColor: '#BFBFBF',
                    data: rpcGraphVol.map(item => item.totalcommsreceivedG),
                    // data: [24, 88, 56, 74, 32, 64, 78],
                },
                {
                    type: "line",
                    label: appLanguage["report.current-status.label.processed"],
                    fill: false,
                    tension: 0.5,
                    borderColor: '#7F7F7F',
                    backgroundColor: '#7F7F7F',
                    data: rpcGraphVol.map(item => item.totalcommsprocessedG),
                    // data: [12, 24, 25, 8, 70, 36, 53],
                },
                {
                    type: "line",
                    label: appLanguage["report.current-status.label.complete"],
                    fill: false,
                    tension: 0.3,
                    borderColor: '#C00000',
                    backgroundColor: '#C00000',
                    data: rpcGraphVol.map(item => item.totalcommsCompleteG),
                    // data: [26, 22, 76, 27, 65, 44, 29],
                },
            ],
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                tooltips: {
                    mode: "index",
                    intersect: false,
                },
                legend: {
                    display: false
                },

                // legend: {
                //     labels: {
                //         color: textColor,
                //     },
                // },
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                        display: false,
                    },
                },
                y: {
                    stacked: false,
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        };
        setChartData(data);
        setChartOptions(options);
    }, [currentReportList, appLanguage]);

    const downloadCommsStatusReport = () => {
        downloadCsv(currentCommsReportList, 'comms_status_report.csv');
    }

    const downloadRPCReport = () => {
        console.log(currentRPCReportList, "<<<<currentRPCReportList>>>>")
        downloadCsv(currentRPCReportList, 'rpc_report.csv');
    }

    // Convert JSON to CSV
    const jsonToCsv = (jsonData) => {
        const isArray = Array.isArray(jsonData);
        if (isArray) {
            const headers = Object.keys(jsonData[0]);
            const csvRows = [];
            csvRows.push(headers.join(','));
            jsonData.forEach(item => {
                const values = headers.map(header => {
                    const value = item[header];
                    return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
                });
                csvRows.push(values.join(','));
            });
            return csvRows.join('\n');
        } else {
            const headers = Object.keys(jsonData);
            const values = headers.map(header => {
                const value = jsonData[header];
                return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
            });
            return `${headers.join(',')}\n${values.join(',')}`;
        }
    };

    // Trigger CSV download
    const downloadCsv = (jsonData, fileName) => {
        const csvData = jsonToCsv(jsonData);
        console.log('CSV Data:', csvData);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    };

    return (
        <div className="current-status-wrapper">
            <div className="three-col-wrapper">
                <div className="left-col">
                    <CommonReportFilter />
                </div>
                <div className="middle-col">
                    <div className="box-white">
                        <h3>
                            {appLanguage["report.current-status.label.comms-status"]}
                            <span className="button-wrapper">
                                <button title="Download Source Data" onClick={downloadCommsStatusReport} className="download-icon"></button>
                            </span>
                        </h3>
                        <div className="sla-matrics-box">
                            <div className="total-count-box received-title">
                                <h5>{appLanguage["report.current-status.label.received"]}</h5>
                                <h4>{currentReportList[0]?.CommStatus1 ? currentReportList[0]?.CommStatus1[0]?.totalcommsreceived : 0}</h4>
                            </div>
                            <div className="total-count-box">
                                <h5>{appLanguage["report.current-status.label.processed"]}</h5>
                                <h4>{currentReportList[0]?.CommStatus1 ? currentReportList[0]?.CommStatus1[0]?.totalcommsprocessed : 0}</h4>
                            </div>
                            <div className="total-count-box">
                                <h5>{appLanguage["report.current-status.label.complete"]}</h5>
                                <h4>{currentReportList[0]?.CommStatus1 ? currentReportList[0]?.CommStatus1[0]?.totalcommsComplete : 0}</h4>
                            </div>
                        </div>
                        <ul className="sla-matrics-list" style={{ paddingBottom: '85px' }}>
                            <li>
                                <label>{appLanguage["report.current-status.label.total-jobs-in-fligt"]}</label>
                                <span>{currentReportList[0]?.CommStatus2 ? currentReportList[0]?.CommStatus2[0]?.totaljonsinFlight : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.current-status.label.total-jobs-complete"]}</label>
                                <span>{currentReportList[0]?.CommStatus2 ? currentReportList[0]?.CommStatus2[0]?.totalJobsComplete : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.current-status.label.total-jobs-at-sla-risk"]}</label>
                                <span>{currentReportList[0]?.CommStatus2 ? currentReportList[0]?.CommStatus2[0]?.totaljobsatSLARisk : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.current-status.label.total-jobs-in-error"]}</label>
                                <span>{currentReportList[0]?.CommStatus2 ? currentReportList[0]?.CommStatus2[0]?.totalJobsinError : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.current-status.label.predicted-jobs-estimated"]}:</label>
                                <span>{currentReportList[0]?.CommStatus3 ? currentReportList[0]?.CommStatus3[0]?.predictedJobs : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.current-status.label.predicted-comms-estimated"]}:</label>
                                <span>{currentReportList[0]?.CommStatus3 ? currentReportList[0]?.CommStatus3[0]?.predictedComms : 0}</span>
                            </li>
                        </ul>
                        <p className="last-updated">{appLanguage["report.current-status.label.last-update-received"]}{currentReportList[0]?.CommStatus1 ? moment(currentReportList[0]?.CommStatus1[0]?.CommsLastUpdateReceived).format("DD MMM YYYY-HH:mm") : ''}</p>
                    </div>
                </div>
                <div className="right-col">
                    <div className="box-white">
                        <h3>{appLanguage["report.current-status.label.status-timeline"]}</h3>
                        <div className="range-slider-wrapper">
                            <div className="range-slides ds-received">
                                <span className="range-text">{appLanguage["report.current-status.label.received"]}</span>
                                <Slider
                                    value={value}
                                    onChange={(e) => setValue(e.value)}
                                    className="w-4rem"
                                />
                            </div>
                            <div className="range-slides ds-processed">
                                <span className="range-text">{appLanguage["report.current-status.label.processed"]}</span>
                                <Slider
                                    value={value}
                                    onChange={(e) => setValue(e.value)}
                                    className="w-4rem"
                                />
                            </div>
                            <div className="range-slides ds-complete">
                                <span className="range-text">{appLanguage["report.current-status.label.complete"]}</span>
                                <Slider
                                    value={value}
                                    onChange={(e) => setValue(e.value)}
                                    className="w-4rem"
                                />
                            </div>
                            <span className="button-wrapper">
                                <button title="Download Source Data" onClick={downloadRPCReport} className="download-icon"></button>
                                <button
                                    title="Expand Chart"
                                    className="zoom-icon"
                                    onClick={() => navigate("/current-status-expended-report")}
                                ></button>
                            </span>
                        </div>

                        <div className="current-status-graph-wrapper">
                            {/* <Chart
                                type="line"
                                data={lineStylesData}
                                options={chartOptions}
                            /> */}
                            <Chart
                                type="line"
                                data={chartData}
                                options={chartOptions}
                                style={{ minHeight: '345px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CurrentStatusReport;